import { Pipe, PipeTransform } from '@angular/core';
import { UserInfo } from '@thehubz/client/data-access-api';
import { filter, map, Observable, of } from 'rxjs';

@Pipe({
  name: 'nameInitials',
})
export class NameInitialsPipe implements PipeTransform {
  transform(userInfo?: Observable<UserInfo>): Observable<string> {
    if (!userInfo) {
      return of('--');
    }

    return userInfo.pipe(
      filter((userInfo) => Object.keys(userInfo).length !== 0),
      map((userInfo) => {
        if (userInfo.name) {
          const nameArr = userInfo.name.trim().split(' ');
          const firstName = nameArr.length > 0 && nameArr[0] ? nameArr[0] : '';
          const secondName = nameArr.length > 1 && nameArr[1] ? nameArr[1] : '';
          return firstName?.charAt(0).toUpperCase() + secondName?.charAt(0).toUpperCase();
        }
        return '--';
      }),
    );
  }
}
